// 제조 관리 목업 데이터 - 농산물 박스 공장

import type {
  BOM,
  WorkOrder,
  Workstation,
  StockEntry,
} from '../types';

// 작업장 데이터 - 골판지 박스 제조 공정
export const workstations: Workstation[] = [
  {
    id: 'WS001',
    code: 'WS-001',
    name: '골판지 제조기',
    workstationType: '코루게이터',
    hourRate: 120000,
    capacity: 500,
    isActive: true,
    description: '골판지 원단 제조 (B골/E골/BC골)',
  },
  {
    id: 'WS002',
    code: 'WS-002',
    name: '인쇄기 1호',
    workstationType: '플렉소인쇄',
    hourRate: 80000,
    capacity: 300,
    isActive: true,
    description: '3색 플렉소 인쇄기',
  },
  {
    id: 'WS003',
    code: 'WS-003',
    name: '인쇄기 2호',
    workstationType: '플렉소인쇄',
    hourRate: 85000,
    capacity: 350,
    isActive: true,
    description: '4색 플렉소 인쇄기',
  },
  {
    id: 'WS004',
    code: 'WS-004',
    name: '제함기 1호',
    workstationType: '제함',
    hourRate: 70000,
    capacity: 400,
    isActive: true,
    description: '자동 제함기 (소형)',
  },
  {
    id: 'WS005',
    code: 'WS-005',
    name: '제함기 2호',
    workstationType: '제함',
    hourRate: 75000,
    capacity: 450,
    isActive: true,
    description: '자동 제함기 (대형)',
  },
  {
    id: 'WS006',
    code: 'WS-006',
    name: '결속기',
    workstationType: '포장',
    hourRate: 40000,
    capacity: 600,
    isActive: true,
    description: 'PP밴드 자동 결속기',
  },
  {
    id: 'WS007',
    code: 'WS-007',
    name: '품질검사대',
    workstationType: '검사',
    hourRate: 35000,
    capacity: 800,
    isActive: true,
    description: '치수 및 외관 품질 검사',
  },
];

// BOM 데이터 - 농산물 박스 제품
export const boms: BOM[] = [
  {
    id: 'BOM001',
    code: 'BOM-A10',
    name: '사과박스 10kg',
    itemId: 'item-001',
    itemCode: 'BOX-A10',
    itemName: '사과박스 10kg',
    status: 'active',
    isDefault: true,
    qty: 1,
    uom: 'EA',
    items: [
      {
        id: 'BI001',
        itemId: 'item-011',
        itemCode: 'CB-E120',
        itemName: 'E골 골판지 120cm',
        qty: 0.45,
        uom: 'm²',
        rate: 850,
        amount: 382,
      },
      {
        id: 'BI002',
        itemId: 'item-024',
        itemCode: 'SUP-GLUE',
        itemName: '전분 풀',
        qty: 0.015,
        uom: 'kg',
        rate: 1800,
        amount: 27,
      },
      {
        id: 'BI003',
        itemId: 'item-025',
        itemCode: 'SUP-INK',
        itemName: '인쇄 잉크',
        qty: 0.008,
        uom: 'kg',
        rate: 15000,
        amount: 120,
      },
    ],
    operations: [
      {
        id: 'OP001',
        sequence: 1,
        operationName: '인쇄',
        workstation: '인쇄기 1호',
        timeInMins: 0.8,
        hourRate: 80000,
        operationCost: 1067,
      },
      {
        id: 'OP002',
        sequence: 2,
        operationName: '제함',
        workstation: '제함기 1호',
        timeInMins: 0.6,
        hourRate: 70000,
        operationCost: 700,
      },
      {
        id: 'OP003',
        sequence: 3,
        operationName: '품질검사',
        workstation: '품질검사대',
        timeInMins: 0.2,
        hourRate: 35000,
        operationCost: 117,
      },
    ],
    materialCost: 529,
    operationCost: 1884,
    totalCost: 2413,
    createdAt: '2025-01-01',
    updatedAt: '2025-01-15',
  },
  {
    id: 'BOM002',
    code: 'BOM-P15',
    name: '배박스 15kg',
    itemId: 'item-003',
    itemCode: 'BOX-P15',
    itemName: '배박스 15kg',
    status: 'active',
    isDefault: true,
    qty: 1,
    uom: 'EA',
    items: [
      {
        id: 'BI004',
        itemId: 'item-013',
        itemCode: 'CB-BC120',
        itemName: 'BC골 골판지 120cm',
        qty: 0.65,
        uom: 'm²',
        rate: 1100,
        amount: 715,
      },
      {
        id: 'BI005',
        itemId: 'item-024',
        itemCode: 'SUP-GLUE',
        itemName: '전분 풀',
        qty: 0.02,
        uom: 'kg',
        rate: 1800,
        amount: 36,
      },
      {
        id: 'BI006',
        itemId: 'item-025',
        itemCode: 'SUP-INK',
        itemName: '인쇄 잉크',
        qty: 0.012,
        uom: 'kg',
        rate: 15000,
        amount: 180,
      },
    ],
    operations: [
      {
        id: 'OP004',
        sequence: 1,
        operationName: '인쇄',
        workstation: '인쇄기 2호',
        timeInMins: 1.0,
        hourRate: 85000,
        operationCost: 1417,
      },
      {
        id: 'OP005',
        sequence: 2,
        operationName: '제함',
        workstation: '제함기 2호',
        timeInMins: 0.8,
        hourRate: 75000,
        operationCost: 1000,
      },
      {
        id: 'OP006',
        sequence: 3,
        operationName: '품질검사',
        workstation: '품질검사대',
        timeInMins: 0.3,
        hourRate: 35000,
        operationCost: 175,
      },
    ],
    materialCost: 931,
    operationCost: 2592,
    totalCost: 3523,
    createdAt: '2025-01-05',
    updatedAt: '2025-01-15',
  },
  {
    id: 'BOM003',
    code: 'BOM-C20',
    name: '감귤박스 20kg',
    itemId: 'item-006',
    itemCode: 'BOX-C20',
    itemName: '감귤박스 20kg',
    status: 'active',
    isDefault: true,
    qty: 1,
    uom: 'EA',
    items: [
      {
        id: 'BI007',
        itemId: 'item-013',
        itemCode: 'CB-BC120',
        itemName: 'BC골 골판지 120cm',
        qty: 0.72,
        uom: 'm²',
        rate: 1100,
        amount: 792,
      },
      {
        id: 'BI008',
        itemId: 'item-024',
        itemCode: 'SUP-GLUE',
        itemName: '전분 풀',
        qty: 0.025,
        uom: 'kg',
        rate: 1800,
        amount: 45,
      },
      {
        id: 'BI009',
        itemId: 'item-025',
        itemCode: 'SUP-INK',
        itemName: '인쇄 잉크',
        qty: 0.015,
        uom: 'kg',
        rate: 15000,
        amount: 225,
      },
    ],
    operations: [
      {
        id: 'OP007',
        sequence: 1,
        operationName: '인쇄',
        workstation: '인쇄기 2호',
        timeInMins: 1.2,
        hourRate: 85000,
        operationCost: 1700,
      },
      {
        id: 'OP008',
        sequence: 2,
        operationName: '제함',
        workstation: '제함기 2호',
        timeInMins: 1.0,
        hourRate: 75000,
        operationCost: 1250,
      },
      {
        id: 'OP009',
        sequence: 3,
        operationName: '품질검사',
        workstation: '품질검사대',
        timeInMins: 0.3,
        hourRate: 35000,
        operationCost: 175,
      },
    ],
    materialCost: 1062,
    operationCost: 3125,
    totalCost: 4187,
    createdAt: '2025-01-10',
    updatedAt: '2025-01-15',
  },
  {
    id: 'BOM004',
    code: 'BOM-S03',
    name: '딸기박스 3kg',
    itemId: 'item-008',
    itemCode: 'BOX-S03',
    itemName: '딸기박스 3kg',
    status: 'active',
    isDefault: true,
    qty: 1,
    uom: 'EA',
    items: [
      {
        id: 'BI010',
        itemId: 'item-011',
        itemCode: 'CB-E120',
        itemName: 'E골 골판지 120cm',
        qty: 0.28,
        uom: 'm²',
        rate: 850,
        amount: 238,
      },
      {
        id: 'BI011',
        itemId: 'item-024',
        itemCode: 'SUP-GLUE',
        itemName: '전분 풀',
        qty: 0.01,
        uom: 'kg',
        rate: 1800,
        amount: 18,
      },
      {
        id: 'BI012',
        itemId: 'item-025',
        itemCode: 'SUP-INK',
        itemName: '인쇄 잉크',
        qty: 0.006,
        uom: 'kg',
        rate: 15000,
        amount: 90,
      },
    ],
    operations: [
      {
        id: 'OP010',
        sequence: 1,
        operationName: '인쇄',
        workstation: '인쇄기 1호',
        timeInMins: 0.5,
        hourRate: 80000,
        operationCost: 667,
      },
      {
        id: 'OP011',
        sequence: 2,
        operationName: '제함',
        workstation: '제함기 1호',
        timeInMins: 0.4,
        hourRate: 70000,
        operationCost: 467,
      },
      {
        id: 'OP012',
        sequence: 3,
        operationName: '품질검사',
        workstation: '품질검사대',
        timeInMins: 0.15,
        hourRate: 35000,
        operationCost: 88,
      },
    ],
    materialCost: 346,
    operationCost: 1222,
    totalCost: 1568,
    createdAt: '2025-01-12',
    updatedAt: '2025-01-15',
  },
  {
    id: 'BOM005',
    code: 'BOM-V10',
    name: '채소박스 10kg',
    itemId: 'item-009',
    itemCode: 'BOX-V10',
    itemName: '채소박스 10kg',
    status: 'draft',
    isDefault: false,
    qty: 1,
    uom: 'EA',
    items: [
      {
        id: 'BI013',
        itemId: 'item-012',
        itemCode: 'CB-B120',
        itemName: 'B골 골판지 120cm',
        qty: 0.42,
        uom: 'm²',
        rate: 920,
        amount: 386,
      },
      {
        id: 'BI014',
        itemId: 'item-024',
        itemCode: 'SUP-GLUE',
        itemName: '전분 풀',
        qty: 0.012,
        uom: 'kg',
        rate: 1800,
        amount: 22,
      },
    ],
    operations: [
      {
        id: 'OP013',
        sequence: 1,
        operationName: '인쇄',
        workstation: '인쇄기 1호',
        timeInMins: 0.7,
        hourRate: 80000,
        operationCost: 933,
      },
      {
        id: 'OP014',
        sequence: 2,
        operationName: '제함',
        workstation: '제함기 1호',
        timeInMins: 0.5,
        hourRate: 70000,
        operationCost: 583,
      },
    ],
    materialCost: 408,
    operationCost: 1516,
    totalCost: 1924,
    createdAt: '2025-01-20',
    updatedAt: '2025-01-20',
  },
];

// 작업지시 데이터 - 농산물 박스 생산
export const workOrders: WorkOrder[] = [
  {
    id: 'WO001',
    code: 'WO-2025-001',
    bomId: 'BOM001',
    bomCode: 'BOM-A10',
    itemId: 'item-001',
    itemCode: 'BOX-A10',
    itemName: '사과박스 10kg',
    status: 'completed',
    priority: 'high',
    qty: 3000,
    producedQty: 3000,
    pendingQty: 0,
    uom: 'EA',
    plannedStartDate: '2025-01-10',
    plannedEndDate: '2025-01-12',
    actualStartDate: '2025-01-10',
    actualEndDate: '2025-01-11',
    warehouse: 'WH003',
    operations: [
      {
        id: 'WOO001',
        sequence: 1,
        operationName: '인쇄',
        workstation: '인쇄기 1호',
        status: 'completed',
        plannedTime: 2400,
        actualTime: 2300,
        completedQty: 3000,
        startTime: '2025-01-10 08:00',
        endTime: '2025-01-10 18:00',
      },
      {
        id: 'WOO002',
        sequence: 2,
        operationName: '제함',
        workstation: '제함기 1호',
        status: 'completed',
        plannedTime: 1800,
        actualTime: 1700,
        completedQty: 3000,
        startTime: '2025-01-10 19:00',
        endTime: '2025-01-11 10:00',
      },
      {
        id: 'WOO003',
        sequence: 3,
        operationName: '품질검사',
        workstation: '품질검사대',
        status: 'completed',
        plannedTime: 600,
        actualTime: 550,
        completedQty: 3000,
        startTime: '2025-01-11 10:30',
        endTime: '2025-01-11 15:00',
      },
    ],
    salesOrderCode: 'SO-2025-001',
    createdAt: '2025-01-08',
    updatedAt: '2025-01-11',
  },
  {
    id: 'WO002',
    code: 'WO-2025-002',
    bomId: 'BOM003',
    bomCode: 'BOM-C20',
    itemId: 'item-006',
    itemCode: 'BOX-C20',
    itemName: '감귤박스 20kg',
    status: 'in_progress',
    priority: 'urgent',
    qty: 5000,
    producedQty: 3000,
    pendingQty: 2000,
    uom: 'EA',
    plannedStartDate: '2025-01-15',
    plannedEndDate: '2025-01-18',
    actualStartDate: '2025-01-15',
    warehouse: 'WH003',
    operations: [
      {
        id: 'WOO004',
        sequence: 1,
        operationName: '인쇄',
        workstation: '인쇄기 2호',
        status: 'completed',
        plannedTime: 6000,
        actualTime: 5800,
        completedQty: 5000,
        startTime: '2025-01-15 08:00',
        endTime: '2025-01-16 18:00',
      },
      {
        id: 'WOO005',
        sequence: 2,
        operationName: '제함',
        workstation: '제함기 2호',
        status: 'in_progress',
        plannedTime: 5000,
        actualTime: 3000,
        completedQty: 3000,
        startTime: '2025-01-17 08:00',
      },
      {
        id: 'WOO006',
        sequence: 3,
        operationName: '품질검사',
        workstation: '품질검사대',
        status: 'pending',
        plannedTime: 1500,
        actualTime: 0,
        completedQty: 0,
      },
    ],
    salesOrderCode: 'SO-2025-002',
    remarks: '제주감귤농협 긴급 주문',
    createdAt: '2025-01-12',
    updatedAt: '2025-01-17',
  },
  {
    id: 'WO003',
    code: 'WO-2025-003',
    bomId: 'BOM004',
    bomCode: 'BOM-S03',
    itemId: 'item-008',
    itemCode: 'BOX-S03',
    itemName: '딸기박스 3kg',
    status: 'not_started',
    priority: 'high',
    qty: 8000,
    producedQty: 0,
    pendingQty: 8000,
    uom: 'EA',
    plannedStartDate: '2025-01-20',
    plannedEndDate: '2025-01-22',
    warehouse: 'WH003',
    operations: [
      {
        id: 'WOO007',
        sequence: 1,
        operationName: '인쇄',
        workstation: '인쇄기 1호',
        status: 'pending',
        plannedTime: 4000,
        actualTime: 0,
        completedQty: 0,
      },
      {
        id: 'WOO008',
        sequence: 2,
        operationName: '제함',
        workstation: '제함기 1호',
        status: 'pending',
        plannedTime: 3200,
        actualTime: 0,
        completedQty: 0,
      },
      {
        id: 'WOO009',
        sequence: 3,
        operationName: '품질검사',
        workstation: '품질검사대',
        status: 'pending',
        plannedTime: 1200,
        actualTime: 0,
        completedQty: 0,
      },
    ],
    remarks: '논산딸기영농조합 주문',
    createdAt: '2025-01-18',
    updatedAt: '2025-01-18',
  },
  {
    id: 'WO004',
    code: 'WO-2025-004',
    bomId: 'BOM001',
    bomCode: 'BOM-A10',
    itemId: 'item-001',
    itemCode: 'BOX-A10',
    itemName: '사과박스 10kg',
    status: 'not_started',
    priority: 'medium',
    qty: 5000,
    producedQty: 0,
    pendingQty: 5000,
    uom: 'EA',
    plannedStartDate: '2025-01-22',
    plannedEndDate: '2025-01-25',
    warehouse: 'WH003',
    operations: [
      {
        id: 'WOO010',
        sequence: 1,
        operationName: '인쇄',
        workstation: '인쇄기 1호',
        status: 'pending',
        plannedTime: 4000,
        actualTime: 0,
        completedQty: 0,
      },
      {
        id: 'WOO011',
        sequence: 2,
        operationName: '제함',
        workstation: '제함기 1호',
        status: 'pending',
        plannedTime: 3000,
        actualTime: 0,
        completedQty: 0,
      },
      {
        id: 'WOO012',
        sequence: 3,
        operationName: '품질검사',
        workstation: '품질검사대',
        status: 'pending',
        plannedTime: 1000,
        actualTime: 0,
        completedQty: 0,
      },
    ],
    salesOrderCode: 'SO-2025-003',
    createdAt: '2025-01-19',
    updatedAt: '2025-01-19',
  },
  {
    id: 'WO005',
    code: 'WO-2025-005',
    bomId: 'BOM002',
    bomCode: 'BOM-P15',
    itemId: 'item-003',
    itemCode: 'BOX-P15',
    itemName: '배박스 15kg',
    status: 'stopped',
    priority: 'low',
    qty: 2000,
    producedQty: 800,
    pendingQty: 1200,
    uom: 'EA',
    plannedStartDate: '2025-01-08',
    plannedEndDate: '2025-01-12',
    actualStartDate: '2025-01-08',
    warehouse: 'WH003',
    operations: [
      {
        id: 'WOO013',
        sequence: 1,
        operationName: '인쇄',
        workstation: '인쇄기 2호',
        status: 'completed',
        plannedTime: 2000,
        actualTime: 850,
        completedQty: 850,
        startTime: '2025-01-08 08:00',
        endTime: '2025-01-08 16:00',
      },
      {
        id: 'WOO014',
        sequence: 2,
        operationName: '제함',
        workstation: '제함기 2호',
        status: 'pending',
        plannedTime: 1600,
        actualTime: 0,
        completedQty: 0,
      },
      {
        id: 'WOO015',
        sequence: 3,
        operationName: '품질검사',
        workstation: '품질검사대',
        status: 'pending',
        plannedTime: 600,
        actualTime: 0,
        completedQty: 0,
      },
    ],
    remarks: '원자재 부족으로 생산 중단 - BC골 골판지 입고 대기',
    createdAt: '2025-01-05',
    updatedAt: '2025-01-08',
  },
];

// 생산 입고 데이터
export const stockEntries: StockEntry[] = [
  {
    id: 'SE001',
    code: 'SE-2025-001',
    entryType: 'manufacture',
    workOrderId: 'WO001',
    workOrderCode: 'WO-2025-001',
    postingDate: '2025-01-11',
    items: [
      {
        id: 'SEI001',
        itemId: 'item-001',
        itemCode: 'BOX-A10',
        itemName: '사과박스 10kg',
        qty: 3000,
        uom: 'EA',
        rate: 2413,
        amount: 7239000,
        targetWarehouse: 'WH003',
      },
    ],
    totalQty: 3000,
    totalAmount: 7239000,
    createdAt: '2025-01-11',
  },
  {
    id: 'SE002',
    code: 'SE-2025-002',
    entryType: 'material_issue',
    workOrderId: 'WO002',
    workOrderCode: 'WO-2025-002',
    postingDate: '2025-01-15',
    items: [
      {
        id: 'SEI002',
        itemId: 'item-013',
        itemCode: 'CB-BC120',
        itemName: 'BC골 골판지 120cm',
        qty: 3600,
        uom: 'm²',
        rate: 1100,
        amount: 3960000,
        sourceWarehouse: 'WH002',
      },
      {
        id: 'SEI003',
        itemId: 'item-024',
        itemCode: 'SUP-GLUE',
        itemName: '전분 풀',
        qty: 125,
        uom: 'kg',
        rate: 1800,
        amount: 225000,
        sourceWarehouse: 'WH001',
      },
      {
        id: 'SEI004',
        itemId: 'item-025',
        itemCode: 'SUP-INK',
        itemName: '인쇄 잉크',
        qty: 75,
        uom: 'kg',
        rate: 15000,
        amount: 1125000,
        sourceWarehouse: 'WH001',
      },
    ],
    totalQty: 3800,
    totalAmount: 5310000,
    createdAt: '2025-01-15',
  },
  {
    id: 'SE003',
    code: 'SE-2025-003',
    entryType: 'manufacture',
    workOrderId: 'WO002',
    workOrderCode: 'WO-2025-002',
    postingDate: '2025-01-17',
    items: [
      {
        id: 'SEI005',
        itemId: 'item-006',
        itemCode: 'BOX-C20',
        itemName: '감귤박스 20kg',
        qty: 3000,
        uom: 'EA',
        rate: 4187,
        amount: 12561000,
        targetWarehouse: 'WH003',
      },
    ],
    totalQty: 3000,
    totalAmount: 12561000,
    createdAt: '2025-01-17',
  },
];

// 유틸리티 함수
export const getBOMById = (id: string): BOM | undefined => {
  return boms.find((b) => b.id === id);
};

export const getWorkOrderById = (id: string): WorkOrder | undefined => {
  return workOrders.find((wo) => wo.id === id);
};

export const getWorkstationById = (id: string): Workstation | undefined => {
  return workstations.find((ws) => ws.id === id);
};

// 제조 통계
export const getManufacturingStats = () => {
  const totalWorkOrders = workOrders.length;
  const inProgressOrders = workOrders.filter((wo) => wo.status === 'in_progress').length;
  const completedOrders = workOrders.filter((wo) => wo.status === 'completed').length;
  const pendingOrders = workOrders.filter((wo) => wo.status === 'not_started').length;

  const totalPlannedQty = workOrders.reduce((sum, wo) => sum + wo.qty, 0);
  const totalProducedQty = workOrders.reduce((sum, wo) => sum + wo.producedQty, 0);
  const completionRate = totalPlannedQty > 0 ? (totalProducedQty / totalPlannedQty) * 100 : 0;

  const activeBOMs = boms.filter((b) => b.status === 'active').length;
  const activeWorkstations = workstations.filter((ws) => ws.isActive).length;

  return {
    totalWorkOrders,
    inProgressOrders,
    completedOrders,
    pendingOrders,
    totalPlannedQty,
    totalProducedQty,
    completionRate,
    activeBOMs,
    activeWorkstations,
  };
};

// 작업지시 상태별 통계
export const getWorkOrderStatusStats = () => {
  const stats: Record<string, number> = {};
  workOrders.forEach((wo) => {
    stats[wo.status] = (stats[wo.status] || 0) + 1;
  });
  return stats;
};

// 오늘의 작업 공정
export const getTodayOperations = () => {
  const operations: Array<{
    workOrderCode: string;
    itemName: string;
    operationName: string;
    workstation: string;
    status: string;
    completedQty: number;
    totalQty: number;
  }> = [];

  workOrders
    .filter((wo) => wo.status === 'in_progress')
    .forEach((wo) => {
      wo.operations
        .filter((op) => op.status === 'in_progress')
        .forEach((op) => {
          operations.push({
            workOrderCode: wo.code,
            itemName: wo.itemName,
            operationName: op.operationName,
            workstation: op.workstation,
            status: op.status,
            completedQty: op.completedQty,
            totalQty: wo.qty,
          });
        });
    });

  return operations;
};
